import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';

const pulseShadow = keyframes`
  0% {
    box-shadow: 0 0 0 rgba(199, 122, 196, 0);
  }
  50% {
    box-shadow: 0 0 24px rgba(199, 122, 196, 0.24);
  }
  100% {
    box-shadow: 0 0 0 rgba(199, 122, 196, 0);
  }
`;

const StyledContent = styled.button<{
  isRecording?: boolean;
  haveErrorRecording?: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: 12px;
  width: 100%;
  border: 1px solid var(--dk-line, #e7e9ec);
  background-color: var(--dk-bg, white);
  border-radius: 8px;
  border: ${({ isRecording, haveErrorRecording }) =>
    isRecording
      ? '1px solid #C77AC4'
      : haveErrorRecording
      ? '1px solid #F55060'
      : ''};

  ${({ isRecording }) =>
    isRecording &&
    css`
      animation: ${pulseShadow} 2s ease-in-out infinite;
    `}
`;

const StyledFilter = styled.div<{
  colorSet: { color: string; background: string; borderColor: string };
}>`
  color: ${({ colorSet }) => colorSet.color};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  text-transform: uppercase;
  width: fit-content;
  padding: 2px 8px;
  border-radius: 4px;
  background: ${({ colorSet }) => colorSet.background};
  border: 1px solid ${({ colorSet }) => colorSet.borderColor};
  white-space: nowrap;
  display: flex;
  align-items: center;
`;

const TitleLayout = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--dk-line, #e7e9ec);
  width: 100%;
`;

const StyledTitle = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2; // 원하는 라인수
  -webkit-box-orient: vertical;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px; /* 150% */
  text-align: start;
  margin: 12px 0;
`;

const StyledName = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-grow: 1;
  line-height: 20px;
`;

const StyledDepartment = styled.span`
  color: var(--dk-text-secondary, #888d96);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  border-left: 1px solid var(--dk-line, #e7e9ec);
  padding-left: 8px;
  margin-left: 8px;
`;

const StyledHour = styled.div`
  color: var(--dk-text-dim, #b7bbc2);
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  white-space: nowrap;
  padding-left: 8px;
  line-height: 20px;
`;

const StyledImage = styled.img`
  border-radius: 50%;
  width: 24px;
  height: 24px;
  min-width: 24px;
  object-fit: cover;
  margin-right: 8px;
  border: 1px solid var(--dk-bg, white);
`;

const StyledComments = styled.div`
  color: var(--dk-text-secondary, #888d96);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 150% */
`;

const StyledComment = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  display: -webkit-box;
  -webkit-line-clamp: 2; // 원하는 라인수
  -webkit-box-orient: vertical;
  text-align: start;
`;

const CommentLayout = styled.div`
  display: flex;
  align-items: start;
  padding: 4px;
  gap: 8px;
  border-radius: 4px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  margin-top: 12px;
  width: 100%;
`;

const AuthorLayout = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding-top: 12px;
`;

const RecordingBadge = styled.div`
  background-color: #f55060;
  border-radius: 4px;
  padding: 2px 8px;
  color: white;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
`;

const UploadFailureBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background-color: var(--dk-danger-soft, #fef1f2);
  padding: 2px 8px 2px 4px;
  border-radius: 4px;
  border: 1px solid var(--dk-danger-line, #fbb9bf);
  color: var(--dk-danger, #f55060);
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
`;

export {
  StyledComments,
  StyledContent,
  StyledFilter,
  StyledTitle,
  StyledName,
  StyledDepartment,
  StyledHour,
  StyledImage,
  StyledComment,
  CommentLayout,
  AuthorLayout,
  TitleLayout,
  RecordingBadge,
  UploadFailureBadge,
};
